import React from 'react';
import Modal, { ModalBody, ModalFooter } from 'packages/ui/Modal';
import Button from 'packages/ui/Button';

function SuccessModal({ show, onHide }) {
  return (
    <Modal key="modal" onHide={onHide} show={show} size="small">
      <ModalBody>درخواست شما موفقیت ثبت شد</ModalBody>

      <ModalFooter>
        <Button mood="primary" onClick={onHide}>
          حله
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default SuccessModal;
